var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logout (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Affiliate-quarter-dashboard1",
    transform: "translate(-40.000000, -592.000000)",
    fill: "#585555",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(40.000000, 592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout-(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8774737,17.4568421 L2.39242105,17.4568421 L2.39242105,2.53157895 L12.8778947,2.53157895 C13.1103158,2.53157895 13.2989474,2.34294737 13.2989474,2.11052632 L13.2989474,0.56 C13.2989474,0.327578947 13.1103158,0.138947368 12.8778947,0.138947368 L0.421052632,0.138947368 C0.188631579,0.138947368 0,0.327578947 0,0.56 L0,19.428 C0,19.6604211 0.188631579,19.8490526 0.421052632,19.8490526 L12.8774737,19.8490526 C13.1101053,19.8490526 13.2985263,19.6604211 13.2985263,19.428 L13.2985263,17.8778947 C13.2985263,17.6450526 13.1103158,17.4568421 12.8774737,17.4568421 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2852632,9.69642105 L14.6174737,4.02905263 C14.4595789,3.87094737 14.18,3.87115789 14.0221053,4.02905263 L12.6774737,5.37389474 C12.5130526,5.53831579 12.5130526,5.80484211 12.6774737,5.96926316 L15.2374737,8.52968421 L4.15515789,8.52968421 C3.92273684,8.52968421 3.73410526,8.71831579 3.73410526,8.95073684 L3.73410526,11.0374737 C3.73410526,11.2698947 3.92273684,11.4585263 4.15515789,11.4585263 L15.2381053,11.4585263 L12.6781053,14.0189474 C12.5136842,14.1833684 12.5136842,14.4498947 12.6781053,14.6143158 L14.0227368,15.9593684 C14.1016842,16.0383158 14.2090526,16.0827368 14.3204211,16.0827368 C14.4322105,16.0827368 14.5391579,16.0383158 14.6181053,15.9593684 L20.2858947,10.292 C20.3648421,10.2130526 20.4092632,10.1056842 20.4092632,9.99431579 C20.4090526,9.88231579 20.3642105,9.77536842 20.2852632,9.69642105 Z",
    id: "Path"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6b1cc4e6b70bbd00a51e359abcb2166c.svg";
export { ForwardRef as ReactComponent };